'use client';

import type { ComponentProps } from 'react';

import { SortList } from '@/components';
import { useQueryParam } from '@/hooks';
import type { ProductSortType } from '@/types';
import { PATHNAME } from '@/utils';

const {
  QUERY_PARAM: {
    DEFAULT: { SORT_TYPE: DEFAULT_SORT_TYPE },
    SORT_TYPE: { BASE_URL: SORT_TYPE_BASE_URL },
  },
} = PATHNAME;

type CategorySortListProps = Partial<ComponentProps<typeof SortList>>;

const CategorySortList = (props: CategorySortListProps) => {
  const [queryParam, setQueryParam] = useQueryParam<
    Partial<Record<typeof SORT_TYPE_BASE_URL, ProductSortType>>
  >({
    initialValue: {
      [SORT_TYPE_BASE_URL]: undefined,
    },
    routerOptions: {
      scroll: false,
    },
  });

  return (
    <SortList
      {...props}
      value={queryParam[SORT_TYPE_BASE_URL] || DEFAULT_SORT_TYPE}
      onValueChange={value =>
        setQueryParam({
          ...queryParam,
          [SORT_TYPE_BASE_URL]: value,
        })
      }
    />
  );
};

export { CategorySortList };
